import { CompanyContent } from 'src/services/ds.service'
import { ofType, unionize, UnionOf } from 'src/framework'
import { Option } from 'fp-ts/lib/Option'
import { startFetch, stopFetch } from 'src/framework/fetch-reducer'

export interface SelectCompany {
  type: 'SelectCompany'
  company: Option<CompanyContent>
}

export interface UpdateCompany {
  type: 'UpdateCompany'
  id: string
  name: string
  address: string
  postalCode: string
  city: string
  country: string
  phoneNumber: string
  groupingCode: string | null
  creatorToken: string
  [startFetch]: string
}

export interface UpdateCompanySuccess {
  type: 'UpdateCompanySuccess'
  [stopFetch]: string
}

export interface UpdateCompanyFailure {
  type: 'UpdateCompanyFailure'
  [stopFetch]: string
}

export const updateCompanyActions = unionize({
  ...ofType<SelectCompany>('SelectCompany'),
  ...ofType<UpdateCompany>('UpdateCompany'),
  ...ofType<UpdateCompanySuccess>('UpdateCompanySuccess'),
  ...ofType<UpdateCompanyFailure>('UpdateCompanyFailure')
})

export type UpdateCompanyActions = UnionOf<typeof updateCompanyActions>



// WEBPACK FOOTER //
// ./src/companies-components/update-company/update-company.actions.ts